/* eslint-disable no-comments/disallowComments */
export interface BaseEntityDto {
  updatedAt?: string;
  createdAt?: string;
  deletedAt?: string;
  isActive?: boolean;
}
